import { Box, Spinner, VStack } from '@chakra-ui/react';
import React from 'react';
import { TextBlock } from '../../common/components/TextBlock';
import { UI } from '../../common/shells/UI';
import { useDashboardModel } from '../models/DashboardModel';
import { Balance } from './Balance';
import { Banner } from './Banner';
import { Investments } from './Investments';
import { MoneyEarned } from './MoneyEarned';
import { Helmet } from 'react-helmet';

export const DashboardPage: React.FC = () => {
  const model = useDashboardModel();

  return (
    <UI>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Dashboard | Concreit</title>
      </Helmet>
      {model.loading ? (
        <Box w="full" alignItems="center" textAlign={'center'} p={10}>
          <Spinner color="blue.500" size="xl" />
        </Box>
      ) : (
        <VStack w={'100%'} gap="80px" justifyContent="center">
          <Box w="100%">
            <Banner />
            <Box
              mt="30px"
              display={['flex']}
              height={['450px', '450px', '220px']}
              flexDirection={['column', 'column', 'row']}
              gap={'10px'}
              width={'100%'}>
              <Balance />
              <MoneyEarned />
            </Box>
          </Box>
          {/*<Properties />  Not mvp */}
          <Box w="100%">
            <Investments />
          </Box>
          <VStack w="full" gap="28px" alignItems={['center', 'flex-start']} fontSize={'14px'}>
            <TextBlock color="blackAlpha.400">
              *The images above are used for illustrative purposes only and do not represent any investments that are
              held under any Concreit affiliated portfolios.
            </TextBlock>
          </VStack>
        </VStack>
      )}
    </UI>
  );
};
